import React from "react";
import "../Progress/sellerprogressstyles.css";
import defaultImg from "../../../assets/sellerdashboardicons/remainingReach.webp";
import bronzeImg from "../../../assets/sellerdashboardicons/bronzecup.webp";
import silverImg from "../../../assets/sellerdashboardicons/Silvercupimg.webp";
import goldImg from "../../../assets/sellerdashboardicons/Goldcup.webp";

const SellerProgress = ({ salesReport }) => {
  const target = salesReport?.data?.target;
  const targetTotal = Number(target?.target_amount) || 300000;
  const achievedTotal = Number(target?.current_month_acheived_amount||0);
  const rewards = [
    { level: "Bronze", target: targetTotal * 0.25 },
    { level: "Silver", target: targetTotal * 0.50 },
    { level: "Gold", target: targetTotal},
  ];  
  const getCurrentLevel = (achieved, rewards) => {
    const completed = rewards
      .filter((r) => achieved >= r.target)
      .map((r) => r.level.toLowerCase());

    if (completed.length === 0) return "none";

    const order = ["bronze", "silver", "gold"];
    return completed.sort(
      (a, b) => order.indexOf(b) - order.indexOf(a)
    )[0];
  };
  const getProgressPercent = (achieved, target) =>
    target > 0 ? Math.min(100, Math.floor((achieved / target) * 100)) : 0;

  const levelConfig = {
    none: {
      image: defaultImg,
      subtitle: "Every top performer started here",
      message: "Keep Going",
    },
    bronze: {
      image: bronzeImg,
      subtitle: "Congratulations!",
      message: "You're a Bronze Performer",
    },
    silver: {
      image: silverImg,
      subtitle: "Congratulations!",
      message: "You're a Silver Performer",
    },
    gold: {
      image: goldImg,
      subtitle: "Congratulations!",
      message: "You're a Gold Performer",
    },
  };

  const currentLevel = getCurrentLevel(achievedTotal, rewards);
  const config = levelConfig[currentLevel];

  return (
    <div
      className="seller-progress bg-white rounded-2xl"
      style={{ padding: "0px 20px 20px 20px" }}
    >
      {/* Header */}
      <div className="rewards-header mb-8">
        <h3 className="font-semibold text-gray-900 mb-4 Performance-Rewards">
          Performance Rewards
        </h3>

        <div className="flex justify-between items-center cup-plus-content">
          <div className="cup-image-big">
            <img
              src={config.image}
              alt={currentLevel}
              className="object-contain head-cup-images"
            />
          </div>

          <div className="congratulation">
            <p className="text-sm text-black-900 text-center subtitle">
              {config.subtitle}
            </p>
            <p className="text-lg font-bold text-gray-900 mt-1 text-center performer-text">
              {config.message}
            </p>
          </div>
        </div>
      </div>

      {/* Rewards List */}
      <div className="rewards-list space-y-5">
        {rewards.map((reward) => {
          const percent = getProgressPercent(
            achievedTotal,
            reward.target
          );
          const isAchieved = achievedTotal >= reward.target;
          const levelKey = reward.level.toLowerCase();

          return (
            <div key={reward.level} className="reward-card">
              <div className="flex justify-between items-center mb-3">
                <div className="flex items-center gap-3">
                  <img
                    src={levelConfig[levelKey].image}
                    alt={reward.level}
                    className="reward-cup-image"
                  />
                  <div className="h4-performer">
                    <h4 className="font-medium text-gray-900">
                      {reward.level} Performer
                    </h4>
                  </div>
                </div>

                <span className="percentage-number font-semibold text-gray-700">
                  {percent}%
                </span>
              </div>

              <div className="flex items-center justify-between">
                <div className="tartgets-divide flex items-center">
                  <p>
                   
                      ₹{achievedTotal.toLocaleString("en-IN")} /
                   {"  "}
                   </p>
                   <p>
                      <strong>₹{reward.target.toLocaleString("en-IN")}</strong>
                  </p>
                </div>

                <div className="progress-bar">
                  <div
                    className={`progress-fill ${isAchieved ? "achieved" : ""
                      }`}
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SellerProgress;
